import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgS1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 19)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 52,
				y: 3,
				width: 2,
				height: 20,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 47,
				y: 27,
				width: 2,
				height: 15,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 12,
				y: 27,
				width: 2,
				height: 15,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 12,
				y: 3,
				width: 2,
				height: 20,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 7,
				y: 3,
				width: 2,
				height: 20,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				x: 47,
				y: 3,
				width: 2,
				height: 20,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.91 7h8.68v1.73A22 22 0 0032.78 11a17.23 17.23 0 00-1.42 2.56 16.34 16.34 0 00-1 2.86 17.63 17.63 0 00-.51 3.22h-2.26a15.93 15.93 0 01.52-3 18 18 0 011-2.85c.431-.917.933-1.8 1.5-2.64a23.05 23.05 0 011.83-2.38h-6.53V7z",
				fill: "#1D1D1B",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				transform: "rotate(135 9.59 30.59)",
				x: 8.684,
				y: 25.004,
				width: 1.81,
				height: 11.17,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				transform: "rotate(45 51.59 30.59)",
				x: 50.684,
				y: 25.004,
				width: 1.81,
				height: 11.17,
				rx: .9
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: -1,
				y: -1,
				width: 62,
				height: 28,
				rx: 2
			})
		]
	})
});
export default SvgS1;
